<template>
  <SectionPageShell
    section="support"
    :title="ticketTitle"
    subtitle="Support"
    show-back-link
  >
    <div class="card border-0 shadow-sm">
      <div class="card-body p-3 p-lg-4">
      <template v-if="articles.length">
        <div
          v-for="article in articles"
          :key="article.id"
          class="d-flex mb-3"
          :class="isOutgoing(article) ? 'justify-content-end' : 'justify-content-start'"
        >
          <article
            class="card shadow-sm"
            :class="messageCardClass(article)"
            style="max-width: 48rem; width: min(100%, 48rem);"
          >
            <div class="card-body">
              <div
                class="d-flex justify-content-between align-items-center gap-3 small mb-2"
                :class="isOutgoing(article) ? 'text-success-emphasis' : 'text-muted'"
              >
                <strong>{{ senderLabel(article) }}</strong>
                <span class="d-inline-flex align-items-center gap-2 text-nowrap">
                  <span
                    class="d-inline-flex align-items-center"
                    :title="typeLabel(article.type)"
                    :aria-label="typeLabel(article.type)"
                  >
                    <Icon :icon="typeIcon(article.type)" />
                  </span>
                  <span v-if="article.created_at">{{ formatDate(article.created_at, 'datetime') }}</span>
                </span>
              </div>
              <div
                class="lh-base"
                :class="isOutgoing(article) ? 'text-end' : ''"
                v-html="article.body"
              ></div>
            </div>
          </article>
        </div>
      </template>
      <div v-else-if="supportStore.loading" class="text-muted">
        Ticket wird geladen...
      </div>
      <div v-else class="text-muted">
        Keine Nachrichten zu diesem Ticket gefunden.
      </div>

      <div class="border-top pt-3 mt-3">
        <label class="form-label" for="support-reply">Antwort</label>
        <textarea
          id="support-reply"
          v-model="replyMessage"
          class="form-control mb-3"
          rows="4"
          placeholder="Antwort eingeben"
        />
        <button type="button" class="btn btn-warning" @click="sendReply">
          Antwort senden
        </button>
      </div>
      </div>
    </div>
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import { useSupportStore } from "@/stores/support";

export default {
  name: "SupportShowPage",
  components: {
    SectionPageShell,
  },
  setup() {
    return {
      supportStore: useSupportStore(),
    }
  },
  data() {
    return {
      articles: [],
      replyMessage: '',
    }
  },
  created() {
    this.supportStore.get_articles(this.$route.params.ticket_id).then(({data}) => {
      this.articles = data.articles
    }).catch((error) => {
      console.log(error)
    });
  },
  computed: {
    ticketTitle() {
      return `Ticket #${this.$route.params.ticket_id}`
    },
  },
  methods: {
    senderLabel(article) {
      return article.sender === 'Agent' ? 'Support' : 'Sie'
    },
    isOutgoing(article) {
      return article.sender === 'Customer'
    },
    messageCardClass(article) {
      return this.isOutgoing(article)
        ? 'bg-success bg-opacity-10 border-success'
        : 'bg-light border-light-subtle'
    },
    typeIcon(type) {
      return type === 'web' ? 'fa-pro-light:browser' : 'fa-pro-solid:envelope'
    },
    typeLabel(type) {
      return type === 'web' ? 'Web' : 'E-Mail'
    },
    sendReply() {
      const reply = {
        ticket_id: this.$route.params.ticket_id,
        message: this.replyMessage,
      }
      this.supportStore.create_article(reply).then(() => {
        this.replyMessage = ''
        this.supportStore.get_articles(this.$route.params.ticket_id).then(({data}) => {
          this.articles = data.articles
        })
      })
    }
  },
}
</script>

<style scoped lang="scss">
.lh-base :deep(p:last-child) {
  margin-bottom: 0;
}
</style>
